import { render } from "./BoatCard.vue?vue&type=template&id=e225cee0"
import script from "./BoatCard.vue?vue&type=script&lang=js"
export * from "./BoatCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__